import { baseApi } from '../../../config/rtk';

export const privacyConsentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    signConsent: builder.mutation({
      query() {
        return {
          url: `/user/me/consent_signed`,
          method: 'POST',
        };
      },
    }),
  }),
});

export const { useSignConsentMutation } = privacyConsentApi;
